import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import CustomTooltip from '../Tooltip';
import typeOf from '../../helpers/typeOf';

function Hint({ id, hint }) {
    if (!hint) return null;
    return (
        <CustomTooltip id={id} tooltip={hint}>
            <span className="fa fa-question-circle" />
        </CustomTooltip>
    );
}

function DataComponentTableHeader({ multiLevelHeaderNames = [], headerNames = [], columnData = [] }) {
    if (!multiLevelHeaderNames.length && !headerNames.length) return null;

    return (
        <thead>
        {!multiLevelHeaderNames.length ? (
            <tr className="bold">
                {headerNames.map((item, i) => {
                    const data = columnData[i] || {};
                    let value = item;
                    let hint = '';
                    if (typeOf.isObject(item)) {
                        if (!item.disabled && !item.visible) return null;
                        value = item.title;
                        hint = item.hint;
                    }
                    return (
                        <th key={i} {...data}>
                            {typeOf.isString(value) ? Parser(value) : value} <Hint id={i} hint={hint} />
                        </th>
                    );
                })}
            </tr>
        ) : (
            multiLevelHeaderNames.map((items, i) => (
                <tr key={i} className="bold">
                    {items.map((item, j) => (
                        <th key={j} colSpan={item.colspan} rowSpan={item.rowspan}>{item.value}</th>
                    ))}
                </tr>
            ))
        )}
        </thead>
    );
}

DataComponentTableHeader.propTypes = {
    multiLevelHeaderNames: PropTypes.array,
    headerNames: PropTypes.array,
    columnData: PropTypes.array,
};

export default DataComponentTableHeader;
